import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

const enum RestrictionType {
  NAME = 'name',
  EMAIL = 'email',
  NUMBER = 'number',
  TEXT = 'text',
  ONLYTEXT = 'onlytext',
  STREET = 'street',
  COLOR = 'color',
}

@Directive({
  selector: '[appInputRestriction]',
})
export class InputRestrictionDirective {
  @Input() appInputRestriction: any;
  @Output() appInputRestrictionResult: EventEmitter<string>;
  private element: ElementRef;

  constructor(element: ElementRef) {
    this.element = element;
    this.appInputRestrictionResult = new EventEmitter<string>();
    this.appInputRestriction = RestrictionType.NAME;
  }

  @HostListener('input')
  handleInputChange() {
    const regex = this.getRegex(this.appInputRestriction);
    const value: string = this.element.nativeElement.value;
    this.element.nativeElement.value = value.replace(regex, '');
    // this.appInputRestrictionResult.emit(value);
  }

  private getRegex(type: RestrictionType): RegExp {
    let regex;
    switch (type) {
      case RestrictionType.NAME:
        regex = new RegExp(/[^A-ZÁÉÍÓÚa-zñáéíóú' ]/g);
        break;
      case RestrictionType.EMAIL:
        regex = new RegExp(/[^A-Za-z0-9\-_.\@ ]/g);
        break;
      case RestrictionType.NUMBER:
        regex = new RegExp(/[\D]/g);
        break;
      case RestrictionType.TEXT:
        regex = new RegExp(/[^A-ZÁÉÍÓÚa-zñáéíóú0-9.,'"_\- ]/g);
        break;
      case RestrictionType.ONLYTEXT:
        regex = new RegExp(/[^A-ZÁÉÍÓÚa-zñáéíóú ]/g);
        break;
      case RestrictionType.STREET:
        regex = new RegExp(/[^A-ZÁÉÍÓÚa-zñáéíóú0-9.,#\-'/ ]/g);
        break;
      case RestrictionType.COLOR:
        regex = new RegExp(/^#(?:(?:[\da-f]{3}){1,2}|(?:[\da-f]{4}){1,2})$/i);
        break;
      default:
        regex = new RegExp(/[^A-Z0-9ÁÉÍÓÚa-zñáéíóú' ]/g);
    }

    return regex;
  }
}
